import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../../config/constants';

import './style.scss';

const LandingPageHeroWithImage = ({ title, hero, body, showAnchorLinks, paragraphs }) => {
  const { t } = useTranslation();

  const LandingPageHeroWithImageClasses = c('LandingPageHeroWithImage', {
    'LandingPageHeroWithImage--showAnchorLinks': showAnchorLinks,
  });
  return (
    <Container className={LandingPageHeroWithImageClasses}>
      <div className="row">
        <div className="col-12">
          <div className="LandingPageHeroWithImage__hero">
            <h1 className="LandingPageHeroWithImage__title">{title}</h1>
            <div className="LandingPageHeroWithImage__lottie__wrapper">
              <Image
                className="LandingPageHeroWithImage__hero__hero"
                src={{
                  [SCREEN_MOBILE]: hero.get('image_paragraph'),
                  [SCREEN_NORMAL]: hero.get('21_9_normal'),
                  [SCREEN_WIDE]: hero.get('32_9_huge'),
                }}
                lazyload={false}
              />
            </div>
          </div>
        </div>

        {showAnchorLinks ? (
          <>
            <div className="col-12 col-md-6">
              <div className="LandingPageHeroWithImage__body__wrapper">
                <WysiwygField
                  property="schema:text"
                  className="LandingPageHeroWithImage__body LandingPageHeroWithImage__body--with-anchors"
                  html={body}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-5 offset-lg-1 LandingPageHeroWithImage__anchors__wrapper">
              <div className="LandingPageHeroWithImage__anchors">
                <h3>{t('general.directly_to')}</h3>

                {paragraphs.map((paragraph) => {
                  const id = paragraph.get('target_id');
                  const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                  const anchorTitle = paragraph.getIn(['entity', 'field_title', 0, 'value']);
                  return (
                    anchorTitle && (
                      <div key={`${id}:paragrap h:${language}`}>
                        <a className="icon-before icon-arrow" href={`#${id}`}>{anchorTitle}</a>
                      </div>
                    )
                  );
                })}

              </div>
            </div>
          </>
        ) : (
          <div className="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
            <div className="LandingPageHeroWithImage__body__wrapper">
              <WysiwygField
                property="schema:text"
                className="LandingPageHeroWithImage__body"
                html={body}
              />
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default LandingPageHeroWithImage;
